import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect, useState } from 'react';

import { UpdateCheckinEntryDescriptionDocument } from '~/graphql/generated/graphql';

export const useUpdateMemo = (checkinEntryId: string) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [latestMemo, setLatestMemo] = useState({ memo: '', mutationCalled: false });

  const [updateMemo, { data }] = useMutation(UpdateCheckinEntryDescriptionDocument);

  useEffect(() => {
    if (!data) return;

    const latestDescription = data.updateCheckinDescription?.checkinEntry.description || '';
    setLatestMemo({ memo: latestDescription, mutationCalled: true });
  }, [data]);

  const update = useCallback(
    async (visitId: string, memo: string) => {
      setIsUpdating(true);
      setError(null);

      try {
        await updateMemo({
          variables: {
            input: {
              checkinEntryId,
              description: memo,
            },
          },
        });
      } catch (_error) {
        setError(_error?.message ?? 'エラーが発生しました');
      }
      setIsUpdating(false);
    },
    [checkinEntryId, updateMemo],
  );

  useEffect(() => {
    // visitが切り替わった時にリセットする
    setLatestMemo({ memo: '', mutationCalled: false });
  }, [checkinEntryId]);

  return {
    updating: isUpdating,
    error,
    latestMemo,
    update,
  };
};
